import { usePage } from '@inertiajs/vue3'

// return full url, for example '/img/lottie-animatie'
// returns 'https://v2.rentbird.nl/img/lottie-animatie' on production
// and http://rentbird.test/img/lottie-animatie' on local
export const getFullUrl = (string) => {
  const page = usePage()
  return (page.props.appUrl + string)
}
